import { customizedFetch } from "../../services/_customizedFetch";
import { siteConstants } from "../siteUtils";

const API_URL = `${siteConstants.IQ_TECHMAX_API_URL}/image-assets`;

// READs the list of images directly from the SFTP server
export const listImages = () =>
  customizedFetch(`${API_URL}/`, { method: "GET" });

// CREATEs new images by uploading files
export const uploadImages = (files) => {
  const formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    formData.append("images", files[i]);
  }
  return customizedFetch(`${API_URL}/uploadImages`, {
    method: "POST",
    body: formData,
  });
};

// DELETEs a file from the SFTP server
export const deleteImage = (fileURL) =>
  customizedFetch(`${API_URL}/deleteImage`, {
    method: "DELETE",
    body: JSON.stringify({ fileURL }),
    headers: { "Content-Type": "application/json" },
  });
